<template>
  <div>
    <v-tooltip bottom v-if="tooltipText">
      <template v-slot:activator="{ on: tooltip }">
        <div v-on="{ ...tooltip }">
          <v-btn
            :class="buttonClass"
            :small="buttonSmall"
            :color="buttonColor"
            :disabled="disabled"
            @click.stop="dialog = true"
            v-on="{ ...tooltip }"
          >
            <v-icon>{{ buttonIcon }}</v-icon>
          </v-btn>
        </div>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
    <DragForm v-model="dialog">
      <LoadIcon v-if="loading" mt="35" ml="30" style="z-index: 999" />
      <v-card width="600px" :disabled="loading">
        <v-card-title class="headline">{{ dialogTitle }}</v-card-title>

        <v-card-text>
          <v-row max-width="290px" min-width="290px">
            <DateField
              v-bind:placeholder="this.$t('from')"
              :date="dateFrom"
              :prependIcon="'mdi-calendar-range'"
              v-on:changed="(date) => this.onChange(date, 'from')"
            />
            <DateField
              v-bind:placeholder="this.$t('to')"
              :date="dateTo"
              v-on:changed="(date) => this.onChange(date, 'to')"
            />
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="onCancel">
            {{ cancelText }}
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="onOk"
            :disabled="okDisabled"
          >
            {{ okText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </DragForm>
  </div>
</template>

<script>
import DragForm from '@/components/Forms/DragForm.vue';
import DateField from '@/components/DateField';
import LoadIcon from '@/components/LoadIcon';

export default {
  components: {
    DragForm,
    DateField,
    LoadIcon,
  },
  props: {
    buttonClass: {
      type: String,
      default: 'mr-1',
    },
    buttonIcon: {
      type: String,
      default: '',
    },
    buttonDark: {
      type: Boolean,
      default: true,
    },
    buttonSmall: {
      type: Boolean,
      default: true,
    },
    buttonColor: {
      type: String,
      default: 'primary',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    dialogMaxWidth: {
      type: String,
      default: '400px',
    },
    tooltipText: {
      type: String,
      defaultItem: null,
    },
    dialogTitle: {
      type: String,
      default: '',
    },
    dialogText: {
      type: String,
      default: '',
    },
    okText: {
      type: String,
      default: 'Agree',
    },
    cancelText: {
      type: String,
      default: 'Disagree',
    },
    onOkAction: {
      type: Function,
    },
  },
  data() {
    return {
      dialog: false,
      wasBlurred: false,
      okButtonClick: false,
      dateFrom: this.getDate(),
      dateTo: this.getDate(),
      loading: false,
    };
  },
  watch: {
    dialog(flag) {
      if (!flag) {
        this.clear();
      }
    },
  },
  computed: {
    okDisabled() {
      return (
        this.dateFrom === '' ||
        this.dateFrom === undefined ||
        this.dateFrom == null ||
        this.dateTo === '' ||
        this.dateTo === undefined ||
        this.dateTo == null
      );
    },
  },
  methods: {
    async onOk() {
      this.okButtonClick = true;

      if (this.okButtonClick) {
        this.loading = true;

        await this.onOkAction({
          dateFrom: this.dateFrom,
          dateTo: this.dateTo,
        });

        this.loading = false;

        this.dialog = false;
      }
    },
    onCancel() {
      this.$emit('cancel');

      this.dialog = false;
    },
    getDate() {
      var dateNow = new Date();
      var date =
        dateNow.getFullYear().toString() +
        '-' +
        (dateNow.getMonth() + 1).toString().padStart(2, '0') +
        '-' +
        dateNow
          .getDate()
          .toString()
          .padStart(2, '0');

      return date;
    },
    clear() {
      this.loading = false;

      var date = this.getDate();
      this.dateFrom = date;
      this.dateTo = date;
    },

    onChange(date, type) {
      switch (type) {
      case 'from':
        this.dateFrom = date;
        break;
      case 'to':
        this.dateTo = date;
        break;
      }

      if (this.CheckDates()) this.SwapDate();
    },

    CheckDates() {
      if (!this.dateFrom || !this.dateTo) return false;

      const dateTo = this.dateTo.split('-');
      const dateFrom = this.dateFrom.split('-');

      if (dateFrom[0] < dateTo[0]) return false;
      if (dateFrom[0] === dateTo[0] && dateFrom[1] < dateTo[1]) return false;
      if (
        dateFrom[0] === dateTo[0] &&
        dateFrom[1] === dateTo[1] &&
        dateFrom[2] <= dateTo[2]
      )
        return false;

      return true;
    },

    SwapDate() {
      const tmp = this.dateFrom;
      this.dateFrom = this.dateTo;
      this.dateTo = tmp;
    },
  },

  mounted() {
    this.clear();
  },
};
</script>
